'use strict';

define('lib/analytics/blocks/compare.block',[], function () {
  return function compareBlock(compSeries) {
    var comp = compSeries || {};
    return {
      comp_series_brand: comp.brand || '',
      comp_series_grade: comp.grade || '',
      comp_series_year: comp.year || '',
      comp_series_code: comp.model || '',
      comp_series_msrp: comp.msrp || ''
    };
  };
});

